import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { BaseDataManagementTabs } from '../_enums/base-data-management-tabs.enum';

@Injectable({ providedIn: 'root' })
export class BaseDataManagementViewService {
  private readonly activeTabSubject = new BehaviorSubject<BaseDataManagementTabs>(BaseDataManagementTabs.Overview);

  readonly activeTab$: Observable<BaseDataManagementTabs> = this.activeTabSubject.asObservable();

  get activeTab(): BaseDataManagementTabs {
    return this.activeTabSubject.value;
  }

  setActiveTab(tab: BaseDataManagementTabs): void {
    if (tab !== this.activeTabSubject.value) {
      this.activeTabSubject.next(tab);
    }
  }

  reset(): void {
    this.setActiveTab(BaseDataManagementTabs.Overview);
  }
}
